export const config = {
  rowSelection: false,
  tableType: 'antd',
  columns: [
    {
      title: '分公司',
      dataIndex: 'companyName',
      width: 160,
      fixed: 'left',
    },
    {
      title: '推送量',
      dataIndex: 'questionnaireSendSize',
      width: 160,
    },
    {
      title: '员工姓名',
      dataIndex: 'staffName',
      width: 160,
    },
    {
      title: '岗位',
      dataIndex: 'position',
      width: 100,
    },
    {
      title: '部门',
      dataIndex: 'department',
      width: 140,
    },
    {
      title: '员工状态',
      dataIndex: 'staffStatus',
      width: 120,
    },
    {
      title: 'NPS推荐数',
      dataIndex: 'npsRecommendSize',
      width: 120,
    },
    {
      title: '问卷回收数量',
      dataIndex: 'questionnaireSize',
      width: 120,
    },
    {
      title: '满意数',
      dataIndex: 'satisfactionSize',
      width: 100,
    },
    {
      title: '满意率(%)',
      dataIndex: 'satisfactionRate',
      width: 140,
    },
    {
      title: '操作',
      dataIndex: 'action',
      fixed: 'right',
      width: 130,
      render: 'operationFn',
    },
  ],
  search: [
    {
      name: 'companyId',
      label: '分公司',
      itemType: 'select',
      key: 'id',
      labelKey: 'name',
      data: 'companyList',
      allowClear: true,
      events: ['onChange:onCompanyChange'],
    },
    {
      name: 'ucenterId',
      label: '员工名称',
      itemType: 'select',
      key: 'ucenterUserId',
      labelKey: 'userName',
      showSearch: true,
      allowClear: true,
      notFoundContent: '请选择公司或无匹配数据',
      data: 'staffList',
    },
    {
      name: 'date',
      label: '评价时间',
      itemType: 'autoDate',
      showTime: 'true',
      allowClear: 'true',
    },
  ],
  footer: [
    {
      label: '导出',
      type: 'primary',
      status: ['loading:exportLoading'],
      events: ['onClick:onExport'],
    },
  ],
}
